export const LOADING_FAQS = "LOADING_FAQS";
export const SUCCESS_GET_FAQS = "SUCCESS_GET_FAQS";
export const SET_ERROR_FAQS = "SET_ERROR_FAQS";
export const RESET = "RESET";